import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  getSymbolList,
  getMyPrediction,
  getGoogleSheet,
  getDeliveryPercentList,
} from "../action/api-services";
import StockAction from "../component/stockAction";
import moment from "moment";
import PageLoader from "../component/loader";
import DeliveryGraph from "../component/deliveryGraph";
import SectorPanchang from "../component/sectorPanchag";
import StockStrength from "../component/stockStrength";
import { NSE_filter_marketcap, sortStockDataByDateDesc } from "../utils/constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import { btstPredict, checkTrueVolumes, slopeAngle, detectAscendingTriangle, detectNR7WithTrend, hasBullishRunPattern, hasWeeklyBullishRunPattern, isBullishEngulfing, isMorningStar, linearRegression, detectBullishFVGReversal, detectBearishFVGReversal, calculateTrend, analyzeMarket, retestStrategy, insideRangeGap, detectWeeklyFakeBreakdown, weeklyFakeBreakdownScanner, detectWeeklyLiquidityInducement, detectSwingLiquidityInducement } from "../utils/utilsFunctions";

const SmartMoneyPage = () => {
  const [loader, setLoader] = useState(false);
  const [deliveryByDateDataBase, setDeliveryByDateDataBase] = useState([]);
  const [deliveryByDateData, setDeliveryByDateData] = useState([]);
  const [deliveryData, setDeliveryData] = useState([]);
  const [series, setSeries] = useState("EQ");

  const [todayTime, setTodayTime] = useState(new Date());
  const [todayData, setTodayData] = useState([]);
  const [symbolData, setSymbolData] = useState([]);
  const [predictionData, setPredictionData] = useState([]);

  const [startDate, setStartDate] = useState(todayTime);
  const [open, setOpen] = useState(false);
  const userToken = useSelector((state) => state.userToken.value);
  const pastDate = useSelector((state) => state.pastDate.value);
  const navigate = useNavigate();
  const [trends, setTrends] = useState('');

  const currentDate = moment(startDate).format("YYYY-MM-DD");
  const maxDate = pastDate[0].max_date;
  const [deliveryDate, setDeliveryDate] = useState();

  const deliveryDataList = useSelector((state) => state.deliveryData.value);
  const [getTodayPrice, setTodayPrice] = useState([]);
  
  

  const isWeekdayAllowed = (date) => {
    const day = date.getDay();
    date.setDate(date.getDate() - 1);
    const excludeDate = date.toISOString().split("T")[0];

    return day !== 0 && day !== 6; // Exclude weekends and holidays
    // return day !== 0 && day !== 6 && !YearHolidays.includes(excludeDate);
  };

  useEffect(() => {
    if (userToken) {
      getSymbolList(series, '', userToken)
        .then(function (response) {
          setSymbolData(response.data.data);
        })
        .catch(function (err) {
          console.log("Error", err);
        });
    } else {
      navigate(`/`);
    }
  }, [userToken]);


  useEffect(() => {
          if (!userToken) return;
          const current_date = moment(currentDate).format("DDMMYY");
          setLoader(true);
          Promise.all([
              getGoogleSheet("", userToken),
              getDeliveryPercentList(current_date, '', '', '', 'EQ', '', userToken),
              getMyPrediction(current_date, userToken),
            ])
            .then(([googleRes, deliveryRes, predictionRes]) => {
              setTodayTime(googleRes.data.data.datetime);
              setTodayData(googleRes.data.data.json_data);
              setDeliveryByDateDataBase(deliveryRes.data.data);
              setPredictionData(predictionRes.data.data);
              // setLoader(false);
            })
            .catch(console.error)
            .finally(() => setLoader(false));

  }, [currentDate, userToken]);



useEffect(() => {
  if (
    !deliveryByDateDataBase?.length ||
    !symbolData?.length ||
    !predictionData?.length ||
    !todayData?.length
  ) {
    return;
  }

  // ---------- MarketCap filter ----------
  const minMarketCap =
    series === "ETF" || series === "BOND" ? 0 : NSE_filter_marketcap;

  // ---------- Date logic (FIXED) ----------
  const effectiveDate = currentDate ? new Date(currentDate) : null;
  const isAfterMaxDate =
    effectiveDate && maxDate
      ? effectiveDate > new Date(maxDate)
      : false;

  // ---------- Build filtered data ----------
  const filteredData = deliveryByDateDataBase
    .filter(obj =>
      symbolData.some(
        s =>
          s.symbol === obj.symbol &&
          s.series === series &&
          Number(s.MarketCap) >= minMarketCap
      )
    )
    .map(item => {
      const match = symbolData.find(s => s.symbol === item.symbol);
      const prediction = predictionData.find(p => p.symbol === item.symbol);
      const todayLTP = todayData.find(t => t.TICKER === item.symbol);

      const lastPrice = item.stock_data?.[0];
      if (!lastPrice) return null;

      // ---------- Build today candle ----------
      const todayPrice = {
        prev_close: Number(lastPrice.close_price),
        open_price: Number(todayLTP?.OPEN ?? 0),
        close_price: Number(todayLTP?.LTP ?? 0),
        high_price: Number(todayLTP?.HIGH ?? 0),
        low_price: Number(todayLTP?.LOW ?? 0),
        chn_per: Number(todayLTP?.CHANGEPER ?? 0),
        avg_price: lastPrice.avg_price,
        SMA20: lastPrice.SMA20,
        SMA50: lastPrice.SMA50,
        SMA200: lastPrice.SMA200,
        delivery_per: lastPrice.delivery_per,
        delivery_date: todayLTP
          ? todayLTP.DATETIME.split("T")[0]
          : lastPrice.delivery_date,
        delivery_qty: lastPrice.delivery_qty,
        ttl_trd_qty: Number(todayLTP?.VOLUME ?? 0),
        no_of_trades: lastPrice.no_of_trades,
        MARKETCAP: Number(match?.MarketCap ?? 0),
        SMEntery: lastPrice.SMEntery,
        volume_spike: lastPrice.volume_spike,
      };

      // ---------- Stock data (NO mutation) ----------
      const updatedStockData = isAfterMaxDate
        ? [todayPrice, ...item.stock_data]
        : [...item.stock_data];

      return {
        ...item,
        stock_data: sortStockDataByDateDesc(updatedStockData),
        details: match,
        prediction,
        todayLTP,
      };
    })
    .filter(Boolean);

  if (!filteredData.length) return;

  // ---------- Set delivery date safely ----------
  const firstStock = filteredData[0];
  const deliveryDateToSet = isAfterMaxDate
    ? firstStock.stock_data[1]?.delivery_date
    : firstStock.stock_data[0]?.delivery_date;

  if (deliveryDateToSet) {
    setDeliveryDate(deliveryDateToSet);
  }

  // ---------- Final state update ----------
  setDeliveryByDateData(filteredData);

}, [
  deliveryByDateDataBase,
  symbolData,
  predictionData,
  todayData,
  currentDate,
  maxDate,
  series,
]);


  useEffect(() => {
        setDeliveryData([]);
    if (deliveryByDateData) {
        let filterData = [];
        if(trends === "MTF"){
          filterData = deliveryByDateData.filter((item) => {
              if(item.stock_data.length > 20){
                      let lastOne = item.stock_data[item.stock_data.length - 1];
                      let firstOne = item.stock_data[0];
                      
                      const data = item.stock_data;
                      let bullishDaily =  hasBullishRunPattern(data);
                      let bullishWeekly = hasWeeklyBullishRunPattern(data);
                      let trueVolume = checkTrueVolumes(data);
                      const delivery = item.stock_data[0]?.delivery_per;
                      const preDelivery = item.stock_data[1]?.delivery_per;
                      // console.log(">>>>", firstOne.delivery_date + ' -- '+ lastOne.delivery_date);     
                      // console.log(bullishDaily, bullishWeekly)
                      return (
                            bullishDaily === true 
                            && bullishWeekly === true                            
                            && firstOne.close_price > lastOne.close_price
                            && trueVolume === true
                            && delivery > preDelivery
                      );
              }
            });
        }else if(trends === "Swingsetup"){
          // console.log(deliveryByDateData)
          filterData = deliveryByDateData.filter((item) =>{
            if(item.stock_data.length > 20){                      
                      const data = item.stock_data || [];
                      const today = item.todayLTP;
                      const prediction = item.prediction;
                      const volume = parseInt(item.stock_data[0]?.ttl_trd_qty);
                      const preVolume = parseInt(item.stock_data[1]?.ttl_trd_qty);
                      const delivery = parseFloat(item.stock_data[0]?.delivery_per);
                      const preDelivery = parseFloat(item.stock_data[1]?.delivery_per);
                      // console.log(">>", data);

                      return (
                        parseFloat(today.LTP) > parseFloat(item.stock_data[0].SMA20)
                        && parseFloat(item.stock_data[0].SMA20) > parseFloat(item.stock_data[0].SMA50)
                        && parseFloat(item.stock_data[0].SMA50) > parseFloat(item.stock_data[0].SMA200)
                        && parseFloat(today.LTP) > parseFloat(prediction.vwap)
                        && parseFloat(prediction.datr) > parseFloat(prediction.adtr)
                        && parseFloat(prediction.rsi) > 55
                        && parseFloat(prediction.adx) > 30
                        // && delivery > preDelivery
                        && volume > preVolume
                        && checkTrueVolumes(data) === true
                        && volume > parseInt(prediction.avg_volume)
                        && parseFloat(item.stock_data[0].delivery_per) > 40  
                      )
                   
            }
          })

        }else if(trends === "BTSTsetup"){
            /* Thumb Rule 
                  * This works only updrend stock
                  * Stock is <= 5% of 52w High
                  * 
            */
              filterData = deliveryByDateData.filter((item) => {   
                    if(item.stock_data.length > 20){                                               
                          const prices = item.stock_data.map(i => parseFloat(i.close_price));
                          const btst = btstPredict(prices);
                          const volume = item.stock_data[0]?.ttl_trd_qty;
                          const preVolume = item.stock_data[1]?.ttl_trd_qty;
                          let lastOne = item.stock_data[item.stock_data.length - 1];
                          let firstOne = item.stock_data[0];

                          return (
                            btst.bias === "BULLISH"
                            && volume > preVolume
                            && prices[0] > 50
                            && checkTrueVolumes(item.stock_data) === true
                            && parseFloat(item.stock_data[0].open_price) > parseFloat(item.stock_data[0].SMA20)
                            && parseFloat(item.stock_data[0].SMA20) > parseFloat(item.stock_data[0].SMA50)
                            && parseFloat(item.stock_data[0].SMA50) > parseFloat(item.stock_data[0].SMA200)
                            && firstOne.close_price > lastOne.close_price
                          );
                    }
              })
                        
              // console.log("filterData", filterData);

        
        }else if(trends === "NR7setup"){
          
          filterData = deliveryByDateData.filter((item) => {     
                          const stock_data =  item?.stock_data;
                          const NR7Data = detectNR7WithTrend(stock_data)
                          // console.log("NR7Data",  item.symbol, NR7Data);                                                 

                          return (
                            NR7Data.valid === true
                            && NR7Data.isBreakout === true
                            && stock_data[0]?.close_price > 50
                            && checkTrueVolumes(stock_data) === true
                            && parseFloat(item.stock_data[0].MARKETCAP) > 1000
                            && parseFloat(item.stock_data[0].open_price) > parseFloat(item.stock_data[0].SMA20)
                            && parseFloat(item.stock_data[0].SMA20) > parseFloat(item.stock_data[0].SMA50)
                            && parseFloat(item.stock_data[0].SMA50) > parseFloat(item.stock_data[0].SMA200)
                          );
              })

                        

        }else if(trends === "AscendingTriangle"){
          filterData = deliveryByDateData.filter((item) => {
            // console.log("item", item)
                    const data = item.stock_data;
                    const a = detectAscendingTriangle(data);
                    const volume = parseInt(item.stock_data[0]?.ttl_trd_qty);
                    const preVolume = parseInt(item.stock_data[1]?.ttl_trd_qty);
                    const delivery = parseFloat(item.stock_data[0]?.delivery_per);
                    const preDelivery = parseFloat(item.stock_data[1]?.delivery_per);
                    return a.isBreakout === true 
                          && checkTrueVolumes(data) === true
                          && volume > preVolume
                          && delivery > preDelivery
                          && parseFloat(item.stock_data[0].open_price) > parseFloat(item.stock_data[0].SMA20)
                          && parseFloat(item.stock_data[0].SMA20) > parseFloat(item.stock_data[0].SMA50)
                          && parseFloat(item.stock_data[0].SMA50) > parseFloat(item.stock_data[0].SMA200)
          });

        }else if(trends === "GoldenCrossover"){
          filterData = deliveryByDateData.filter((item) => {
            // console.log("item", item)
                    const data = item.stock_data;
                    const today = item.stock_data[0];
                    const prev  = item.stock_data[1];
                    const goldenCross = prev.SMA50 <= prev.SMA200 &&  today.SMA50 > today.SMA200;

                    const prices = data.map(d => Number(d.close_price)).filter(v => Number.isFinite(v)).slice().reverse();
                    if(prices.length < 20){
                      return false;
                    }  

                    const { slope } = linearRegression(prices);
                    const priceRange = Math.max(...prices) - Math.min(...prices) || 1;
                    const slopeStrength = slope / priceRange;
                    const sma50Slope = (today.SMA50 - data[7]?.SMA50) / 7;

                    const avgVolume = data.slice(1, 11).reduce((s, d) => s + Number(d.ttl_trd_qty || 0), 0) / 10;
                    const volumeSpike = Number(today.ttl_trd_qty) > avgVolume * 1.5;
                    // const deliveryStrong = Number(today.delivery_per) >= 50 && Number(today.delivery_per) > Number(prev.delivery_per);

                    const gapPct = ((today.SMA50 - today.SMA200) / today.SMA200) * 100;
                    

                    
                    const volume = parseInt(today?.ttl_trd_qty);
                    const preVolume = parseInt(prev?.ttl_trd_qty);
                    const delivery = parseFloat(today?.delivery_per);
                    const preDelivery = parseFloat(prev?.delivery_per);
                    return goldenCross === true 
                          // && parseFloat(today.close_price) > parseFloat(today.SMA20)
                          && checkTrueVolumes(data) === true
                          && gapPct < 3
                          // && volumeSpike === true
                          && sma50Slope > 0
                          && slopeStrength > 0
                          
                          
                          
                          
          });
        }else if(trends === "Consolidation"){
            filterData = deliveryByDateData.filter((item) => {
              const stock = item.stock_data;
              if (!stock || stock.length < 20) return false;

              const count = (stock).slice(0, 5).filter((row) => {
                  return Number(row.volume_spike) === 1 || Number(row.SMEntery) === 1                
              }).length;

              const data = stock.slice(1, stock.length - 1);
              const swingHigh = Math.max(...data.map(d => Number(d.high_price)));
              const swingLow  = Math.min(...data.map(d => Number(d.low_price)));
              const rangePct = ((swingHigh - swingLow) / swingLow) * 100;

              const avgRecentVol = stock.slice(0, 5).reduce((s, d) => s + Number(d.ttl_trd_qty || 0), 0) / 5;
              const avgPastVol = stock.slice(5, 15).reduce((s, d) => s + Number(d.ttl_trd_qty || 0), 0) / 10;
              let currentPrice = stock[0].close_price;

              return (
                count >= 2
                && currentPrice > swingHigh * 1.01
                && rangePct < 10
                && avgRecentVol > avgPastVol
                && parseFloat(stock[0].close_price) > parseFloat(stock[0].SMA50)
                && parseFloat(stock[0].SMA50) > parseFloat(stock[0].SMA200)
                // && checkTrueVolumes(data) === true
                
              );
            })
          
      }else if(trends === "Uptrend"){
            filterData = deliveryByDateData.filter((item) => {
              const stock = item.stock_data;
              if (!stock || stock.length < 20) return false;

              const data = stock.slice(1, stock.length - 1);

              const avgRecentVol = stock.slice(0, 5).reduce((s, d) => s + Number(d.ttl_trd_qty || 0), 0) / 5;
              const avgPastVol = stock.slice(5, 15).reduce((s, d) => s + Number(d.ttl_trd_qty || 0), 0) / 10;
              const prices = stock.slice().sort((a, b) => new Date(a.delivery_date) - new Date(b.delivery_date))
                                  .map(item => Number(item.close_price) || 0);
              let angle_5n = slopeAngle(prices);


              return (
                angle_5n > 30
                && avgRecentVol > avgPastVol
                && parseFloat(stock[0].close_price) > parseFloat(stock[0].SMA20)
                && parseFloat(stock[0].SMA20) > parseFloat(stock[0].SMA50)
                && parseFloat(stock[0].SMA50) > parseFloat(stock[0].SMA200)
                && checkTrueVolumes(data) === true
                
              );
            }).map((item) =>{
              let stockData = item.stock_data.slice(0, 3).reverse();
              return{
                ...item,
                method: null
              }
            })  
      }else if(trends === 'MorningStar'){
        filterData = deliveryByDateData.filter((item) => {
            const stock = item.stock_data;
              if (!stock || stock.length < 20) return false;

              const stockData = stock.slice(0, 3).reverse();
              const MorningStar = isMorningStar(stockData, stockData.length - 1);
              return (
                MorningStar === true
                && parseFloat(stock[0].close_price) > parseFloat(stock[0].SMA20)
                && parseFloat(stock[0].SMA20) > parseFloat(stock[0].SMA50)
                && parseFloat(stock[0].SMA50) > parseFloat(stock[0].SMA200)
                && checkTrueVolumes(stock) === true
                
              );

        }).map((item) =>{
              let stockData = item.stock_data.slice(0, 3).reverse();
              return{
                ...item,
                method: isMorningStar(stockData, stockData.length - 1)
              }
            })
      }else if(trends === "BullishEngulfing"){
        filterData = deliveryByDateData.filter((item) => {
            const stock = item.stock_data;
              if (!stock || stock.length < 5) return false;

              const stockData = stock.slice(0, 3);
              const BullishEngulfing = isBullishEngulfing(stockData)
              
              return (
                BullishEngulfing === true
                && parseFloat(stockData[2].close_price) > parseFloat(parseFloat(stockData[2].open_price))
                // && parseFloat(stockData[2].close_price) > parseFloat(stockData[2].SMA20)
                && parseFloat(stockData[2].SMA20) > parseFloat(stockData[2].SMA50)
                && parseFloat(stockData[2].SMA50) > parseFloat(stockData[2].SMA200)
                // && checkTrueVolumes(stock) === true
                
              );

        }).map((item) =>{
              let stockData = item.stock_data.slice(0, 3);
              return{
                ...item,
                method: isBullishEngulfing(stockData)
              }
            })
      }else if(trends === "FVGDown"){
            filterData = deliveryByDateData.filter((item) => {
                      let stockData = item.stock_data;
                      let fvg = detectBearishFVGReversal(stockData);
                return(
                      fvg
                      && parseFloat(stockData[0].chn_per) > 0
                      // && parseFloat(stockData[0].SMA50) > parseFloat(stockData[0].SMA200)
                      && checkTrueVolumes(stockData) === true
                )

            }).map((item) =>{
              let stockData = item.stock_data;
              const updatedDeliveryDataList = deliveryDataList.find((s) => s.symbol === item.symbol)

              return{
                ...item,
                // method: detectBearishFVGReversal(stockData),
                // todayPrice: updatedDeliveryDataList.stock_data
              }
            })

          // console.log("filterData", filterData)

      } else{
         filterData = deliveryByDateData.filter((item) => {
                      const stock = item.stock_data;
                      if (!stock || stock.length < 20) return false;

                      console.log(stock[2])
                      
                     

                      // const avgRecentVol = stock.slice(0, 5).reduce((s, d) => s + Number(d.ttl_trd_qty || 0), 0) / 5;
                      // const avgPastVol = stock.slice(5, 15).reduce((s, d) => s + Number(d.ttl_trd_qty || 0), 0) / 10;
                      const prices = stock.slice().sort((a, b) => new Date(a.delivery_date) - new Date(b.delivery_date))
                                          .map(item => Number(item.close_price) || 0);
                      let angle_5n = slopeAngle(prices);
                      let trend = analyzeMarket(stock);
                      
                      
                      

                  
                      

                return(

                      (stock[2]['FVG'] === "BEARISH" && parseFloat(stock[2]['FVG_Body']) > 5) 
                     
                      // && trend?.trend === "BULLISH" || BEARISH
                      // && trend?.confidence > 85
                      && (trend?.structure === "UPTREND" || trend?.structure === "RANGE")

                      
                      // && parseFloat(stockData[0].chn_per) > 0
                      // && angle_5n > 0
                      && parseFloat(stock[0].close_price) > 100
                      && parseFloat(stock[0].SMA50) > parseFloat(stock[0].SMA200)
                      && checkTrueVolumes(stock) === true
                )

            }).map((item) =>{
              let stockData = item.stock_data;
              

              return{
                ...item,
                // method: detectBearishFVGReversal(stockData),
                // todayPrice: updatedDeliveryDataList.stock_data
              }
            })
      }

          setDeliveryData(filterData);
    }
  }, [deliveryByDateData, trends]);

  const handleTrends = (e) =>{
        setTrends(e.target.value);
    }

  return (
    <React.Fragment>
      <div className="pageContainer">
        <React.Fragment>
          <div className="container-fluid actionControler py-3">
            <div className="row">
              {/* <div className="col-md-2 col-sm-6 pe-md-0 mb-sm-3 mb-md-0">
                <div className="form-floating">
                  <input
                    type="text"
                    className="form-control"
                    id="symbolSearch"
                    placeholder="Search"
                    onKeyUp={(e) => handleSearch(e.target.value)}
                  />
                  <label htmlFor="symbolSearch">Search</label>
                </div>
              </div> */}
              <div
                className="col-md-2 col-sm-6 pe-md-0 mb-sm-3 mb-md-0"
                style={{ maxWidth: "350px" }}
              > 
                <DatePicker
                  placeholderText={"Select date"}
                  className="form-control"
                  selected={startDate}
                  open={open}
                  onClickOutside={() => setOpen(false)}
                  onInputClick={() => setOpen(true)}
                  onChange={(date) => {
                    setStartDate(date);
                    setOpen(false); // 👈 CLOSE UI
                  }}
                  dateFormat="dd/MM/YYYY"
                  minDate={moment().subtract(13, "days")}
                  maxDate={moment(todayTime).format("YYYY-MM-DD")}
                  filterDate={isWeekdayAllowed}
                  
                />
              </div>

              <div className="col-md-2 col-sm-6">
                <div className="form-floating">
                  <select
                    className="form-control"
                    id="trends"
                    defaultValue={trends}
                    onChange={(e) => handleTrends(e)}
                  >
                    
                    <option></option>
                    <option value="Uptrend">Uptrend</option>
                    <option value="MTF">MTF - MWD</option>
                    <option value="Swingsetup">Swing Setup</option>
                    <option value="BTSTsetup">BTST Setup</option>
                    <option value="NR7setup">NR7 Setup</option>
                    <option value="AscendingTriangle">Ascending Triangle Setup</option>
                    <option value="Consolidation">Consolidation</option>
                    <option value="MorningStar">Morning Star Setup</option>
                    <option value="BullishEngulfing">Bullish Engulfing Setup</option>                    
                    <option value="GoldenCrossover">Golden Crossover</option>
                    <option value="FVGDown">FVG Down</option>                    
                  </select>
                  <label htmlFor="trends">Trends</label>
                </div>
              </div>
            </div>
          </div>
          
          {loader === true? (
            <PageLoader />
          ) : (
            <div className="pagewrap">
              {deliveryData.length > 0?
              <table className="increaseOI table-responsive">
                <thead>
                  <tr key={`item_0`}>
                    <th style={{ width: "auto" }}>
                      Symbol [{deliveryData?.length}/
                      {deliveryByDateData?.length}]
                    </th>
                    <th style={{ width: "15px" }}></th>
                    <th style={{ width: "38px" }}></th>
                    <th style={{ width: "50px", textAlign: "left" }}>Strength</th>
                    <th style={{ width: "140px", textAlign: "left" }}>Sector</th>
                    <th style={{ width: "45px", textAlign: "left" }}>Series</th>
                    <th style={{ width: "55px", textAlign: "left" }}>Indices</th>
                    <th style={{ width: "60px" }}>Open</th>
                    <th style={{ width: "60px" }}>High</th>
                    <th style={{ width: "60px" }}>Low</th>
                    <th style={{ width: "60px" }}>Close</th>
                    <th style={{ width: "70px" }}>LTP [{moment(todayTime).format("HH:mm")}]</th>
                    <th style={{ width: "60px" }}>Chn%</th>
                    <th style={{ width: "60px" }}>T Chn%</th>
                    <th style={{ width: "60px" }}>Deg° 5</th>
                    <th style={{ width: "60px" }}>SMA200</th>
                    <th style={{ width: "60px" }}>Down 52</th>
                    <th style={{ width: "120px" }}>52 L/H</th>
                    <th style={{ width: "100px" }}>Vol</th>
                    <th style={{ width: "60px" }}>Del%</th>
                    <th style={{ width: "30px" }}>News</th>
                  </tr>
                </thead>
                <tbody>
                  {deliveryData?.map((obj, index) => {
                    // console.log(obj);
                    const symbolName = obj.symbol;
                    const tradingDay = obj.stock_data[0];
                    const price = obj.todayLTP.LTP;
                    let high52w = obj.details?.high52w
                      ? obj.details?.high52w
                      : "";
                    let low52w = obj.details?.low52w
                      ? obj.details?.low52w
                      : "";
                    let highDate = obj.details?.highDate
                      ? moment(obj.details?.highDate).format("DD-MM-YY")
                      : "";
                    let lowDate = obj.details?.lowDate
                      ? moment(obj.details?.lowDate).format("DD-MM-YY")
                      : "";
                    
                    const prices = obj.stock_data
                                        .slice().sort((a, b) => new Date(a.delivery_date) - new Date(b.delivery_date))
                                        .map(item => Number(item.close_price) || 0);
                    let angle_5n = slopeAngle(prices);
                    

                    // let angle_5 = degAngle(
                    //   obj.prediction?.price_5,
                    //   today_close_price,
                    //   5
                    // );

                    

                    


                    return (
                      <tr
                        className={`tr_${obj.details?.id}`}
                        key={`row_item_${index + 1}`}
                        id={`row_item_${index + 1}`}
                      >
                        <td className="symbolName">
                          {symbolName}{" "}
                          {obj.details?.hotStar === "1" ? (
                            <span className="hotStar"></span>
                          ) : null}
                        </td>
                        <td>
                          <StockAction
                            symbol={symbolName}
                            delivery={false}
                            currentPrice={obj.todayLTP?.LTP}
                            deliveryPer={obj.prediction?.delivery_per}
                            hotStar={obj.details?.hotStar}
                            myFev={obj.details?.myFev}
                            eventName={trends === "" ? "Delivery" : trends}
                            rowId={`row_item_${index + 1}`}
                          />
                        </td>
                        <td>
                          <DeliveryGraph
                            symbol={symbolName}
                            todayLTP={obj?.todayLTP}
                            date={moment(deliveryDate).format("YYYY-MM-DD")}
                          />
                        </td>
                        <StockStrength
                          id={`del_${index}`}
                          selectedDate={deliveryDate}
                          symbol={symbolName}
                          todayLTP={obj.todayLTP}
                          details={obj.details}
                          predictions={obj.prediction}
                        />
                        <SectorPanchang
                          symbol={symbolName}
                          sector={obj.details?.group_sector}
                          todayData={todayData}
                          symbolData={symbolData}
                          tag = "td"
                          align = "right"
                          durationDays = ""
                        />
                         <td style={{ textAlign: "left" }}>
                            {obj.details?.series}
                          </td>
                          <td className="indices" style={{ textAlign: "left" }}>
                            {(() => {
                              const label = obj.details?.nifty50
                                ? "50"
                                : obj.details?.nifty100
                                ? "100"
                                : obj.details?.nifty200
                                ? "200"
                                : obj.details?.nifty500
                                ? "500"
                                : obj.details?.totalMarket
                                ? "TM"
                                : "";
                              const excludedSeries = ["ETF", "BOND", "MF"];
                              const showFev =
                                obj.details?.myFev &&
                                !excludedSeries.includes(obj.details?.series);
                              return (
                                label +
                                (showFev ? `${label ? ", " : ""}Fev` : "")
                              );
                            })()}
                          </td>
                          <td>{tradingDay.open_price}</td>
                          <td>{tradingDay.high_price}</td>
                          <td>{tradingDay.low_price}</td>
                          <td>{tradingDay.close_price}</td>
                          <td>{price}</td>
                          <td
                            style={{
                              color:
                                parseFloat(tradingDay.chn_per) > 0
                                  ? "#1c8b16"
                                  : "#f00",
                            }}
                          >
                            {tradingDay.chn_per}%
                          </td>
                           <td>
                            {(
                              ((price - tradingDay.close_price) * 100) /
                              tradingDay.close_price
                            ).toFixed(2)}
                            %
                          </td>
                          <td
                            style={{
                              textAlign: "right",
                              background:
                                parseFloat(angle_5n) > 30
                                  ? "#e2ffe5"
                                  : "#fff8f8",
                            }}
                            title={moment(obj.stock_data[obj.stock_data.length - 1].delivery_date).format("DD-MM-YYYY")}                            
                          >
                            {parseFloat(angle_5n)}°
                          </td>
                          <td
                            style={{
                              textAlign: "right",
                              background:
                                parseFloat(tradingDay.SMA50) >
                                parseFloat(tradingDay.SMA200)
                                  ? "#e2ffe5"
                                  : "#fff8f8",
                            }}
                            title={`DMA50: ${tradingDay.SMA50}`}
                          >
                            {tradingDay.SMA200}
                          </td>
                          <td>
                            <span title={highDate}>
                              {high52w
                                ? (((high52w - price) * 100) / high52w).toFixed(
                                    2
                                  ) + "%"
                                : ""}
                            </span>
                          </td>
                          <td
                            title={`${highDate} / ${lowDate}`}
                          >{`${low52w}/${high52w}`}</td>
                          <td>
                            {Number(tradingDay.ttl_trd_qty).toLocaleString(
                              "en-IN"
                            )}
                          </td>
                          <td>{tradingDay.delivery_per}%</td>
                          <td>
                            <a
                              className="newsicon"
                              href={`https://www.google.com/search?q=is+the+smart+money+accumulation+in+${symbolName}+share+or+why+rising+on+${moment(
                                tradingDay.SMA50.delivery_date
                              ).format("Do MMMM YYYY")}?`}
                              target="_blank"
                            ></a>
                          </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              : <div className="text-center h4 pt-5"> No Stock found for {trends}</div>
                }
            </div>
          )}
        </React.Fragment>
      </div>
    </React.Fragment>
  );
};
export default SmartMoneyPage;
